import { firestoreDb } from './index';
import { sendNotification } from './sendNotification';

import {
  doc,
  onSnapshot,
  getDoc,
  updateDoc,
  arrayUnion
} from 'firebase/firestore'
const CHATPATH = 'giftcard_trade_chats';

const getDocument = async ref => {
  return await getDoc(ref).then(docSnap => formatDataObject(docSnap))
}

const messageRef = messageId => {
  return doc(firestoreDb, CHATPATH, messageId)
}

const formatDataObject = querydata => {
  return querydata.data()
}

export const getMessage = messageId => {
  return getDocument(messageRef(messageId))
}

export const addMessage = async (message, messageId, token, trade) => {
  await updateDoc(messageRef(messageId), {
    messages: arrayUnion(message)
  });
  if (token) {
    sendNotification({
      message: {
        token: token,
        notification: {
          body: message.content,
          title: `New Message from your ${trade} Giftcard trade`
        }
      }
    })
  }
}

export const updateMessage = async (messages, messageId) => {
  await updateDoc(messageRef(messageId), {
    messages: messages
  })
}

export const listenMessages = (messageId, callback) => {
  return onSnapshot(messageRef(messageId), (docSnap) => {
    callback(formatDataObject(docSnap))
  })
}